module.exports = __webpack_public_path__ + "img/sflogo-dark.7f574ea2.png";